const CareerPathwaysPlanLayout = <template>{{outlet}}</template>;

export default CareerPathwaysPlanLayout;
